import { FC } from "react";
import styles from "./style.module.scss";
import { UIText } from "../uIKit";
import { ServiceIncludesList } from "src/utils/types";



const PcPlusCardItem: FC<ServiceIncludesList> = ({
  image,
  imageWidth,
  imageHeight,
  title,
  subTitle,
  options,
}) => {
  return (
    <div className={styles.cardContainer}>
      <div className={styles.imageSection}>
        {imageWidth && imageHeight && (
          <img
            src={image}
            alt={title}
            //   className={styles.image}
            width={imageWidth}
            height={imageHeight}
          />
        )}
      </div>
      <div className={styles.contentSection}>
        <UIText text={title} size={18} weight={600} style={styles.title} />
        <br />
        <div className={styles.subTitleWrapper}>
          <UIText
            text={subTitle}
            size={16}
            weight={400}
            style={styles.subtitle}
          />
        </div>
        <ul className={styles.optionsList}>
          {options?.map((option, index) => (
            <li key={`option-${index}`}>
              <UIText
                key={`option-text-${index}`}
                text={option}
                size={16}
                weight={400}
                style={styles.optionItem}
                />
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default PcPlusCardItem;
